// extracted by mini-css-extract-plugin
export default {"otherButtons":"TaskAppointment_modal_otherButtons__-kv1N"};